var render, staticRenderFns
import script from "./ModalWrap.vue?vue&type=script&lang=js&"
export * from "./ModalWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Server\\domains\\localhost\\ss\\wa-apps\\shop\\plugins\\giftcertificates\\build\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76b0915e')) {
      api.createRecord('76b0915e', component.options)
    } else {
      api.reload('76b0915e', component.options)
    }
    
  }
}
component.options.__file = "src/vue/components/base/modal/ModalWrap.vue"
export default component.exports